export default __webpack_public_path__ + "static/media/WorkBook.96defa41.png";